// extracted by mini-css-extract-plugin
export default {"main":"housingTypePageStyle_main__jS584","toolTipWrapper":"housingTypePageStyle_toolTipWrapper__Pgs1u"};